export const SearchIndexPreferencesKey = "SearchIndexPreferences";
export const ThemePreferencesKey = "ThemePreferences"
